/**
 * className マージヘルパ
 *
 * @graph-stack web-design-system
 * @graph-domain Engineering
 * @graph-business clsx で条件付き className を結合し tailwind-merge で衝突する Tailwind utility を解決する cn helper。共有コンポーネントは全て className prop を本ヘルパでマージし、呼び出し側の上書きを衝突時に勝たせる。
 * @graph-connects none
 */

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * 複数の className 値を結合し、衝突する Tailwind utility を後勝ちで解決する。
 *
 * @param inputs - clsx が受け付ける className 値（文字列・配列・条件付きオブジェクト等）
 * @returns マージ済みの className 文字列
 * @graph-connects none
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
